// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAfYY62_T2fvBj9t2HE6BMZ4iPHl2Me22w",
  authDomain: "dawai-101.firebaseapp.com",
  projectId: "dawai-101",
  storageBucket: "dawai-101.appspot.com",
  messagingSenderId: "115362921074",
  appId: "1:115362921074:web:49a6a490424a9d07f6a0eb",
  measurementId: "G-54VZZMJLDG"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app)
const analytics = getAnalytics(app);